import React from "react";

import { templates } from "@reactivated";

import { CheckoutHeader } from "../components/CheckoutHeader";

export const Template = (
    props: templates.CheckoutHeaderTemplate,
): React.ReactNode => {
    return <CheckoutHeader {...props} />;
};
